import { render } from "./InvestmentAnalysisPage.vue?vue&type=template&id=8a1b520e&scoped=true"
import script from "./InvestmentAnalysisPage.vue?vue&type=script&lang=js"
export * from "./InvestmentAnalysisPage.vue?vue&type=script&lang=js"

import "./InvestmentAnalysisPage.vue?vue&type=style&index=0&id=8a1b520e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1b520e"]])

export default __exports__